window.$ = window.jQuery = require('jquery');
global.moment = require('moment');

require('bootstrap');
require('./nav_submenu');
require('./request');
require('tempusdominus-bootstrap-4');
